import {Button, Table, Tag} from "antd";
import {CSVLink} from "react-csv";
import {MessageOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {useEffect, useState} from "react";
import {SentenceModal} from "./DrugDetailList";

export const DrugDiseaseList = ({ data, isLoading }) => {

  const scoreColor = '#108ee9'
  const [showSentence, setShowSentence] = useState(false)
  const [sentence, setSentence] = useState()

  useEffect(() => {
    console.log(data)
  }, [data])

  const columns = [
    {
      key: 'drug',
      dataIndex: 'drug',
      title: 'Drug',
      render: item => <Link to={`/drugs/${item}`}>{item}</Link>,
      sorter: (a, b) => a.drug.localeCompare(b.drug)
    },
    {
      key: 'disease',
      dataIndex: 'disease',
      title: 'Disease',
      render: item => <Link to={`/diseases/${item}`}>{item}</Link>,
      sorter: (a, b) => a.disease.localeCompare(b.disease)
    },
    {
      key: 'class',
      dataIndex: 'class',
      title: 'Class',
      render: item => <Tag color={item === 'Positive' ? 'success' : item === 'Negative' ? 'error' : 'processing'}>{item}</Tag>,
      filters: [
        {
          text: 'Positive',
          value: 'Positive',
        },
        {
          text: 'Negative',
          value: 'Negative',
        },
      ],
      onFilter: (value, record) => record.class.indexOf(value) === 0,
    },
    {
      key: 'confidence',
      dataIndex: 'confidence',
      title: 'Confidence',
      render: item => <Tag color={scoreColor}>{item}%</Tag>,
      sorter: (a, b) => a.confidence - b.confidence
    },
    {
      key: 'actions',
      title: 'Actions',
      render: (item, record) => <Button onClick={() => {
        setSentence(record.id)
        setShowSentence(true)
      }} icon={<MessageOutlined />} />
    }
  ]

  return(
    <>
      <Table loading={isLoading} columns={columns} rowKey={r => r.id} dataSource={data} />
      <div style={{ textAlign: 'center' }}>
        <Button type="primary">
          <CSVLink filename="drug_disease.csv" data={data}>Download CSV</CSVLink>
        </Button>
      </div>
      <SentenceModal showSentence={showSentence} setShowSentence={setShowSentence} id={sentence} />
      {/*<Modal
        title="Sentence(s)"
        visible={showSentence}
        onOk={() => setShowSentence(false)}
        onCancel={() => setShowSentence(false)}
        centered
        destroyOnClose
        width={1000}
      >
        {sentence}
      </Modal>*/}
    </>
  )
}